import React from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';

const normalizeStatus = (s = '') =>
  String(s).toLowerCase().replace(/\s+|_/g, '-'); // e.g. "Re Submitted" -> "re-submitted"

const ActionDropdown = ({
  rowId,
  status,
  onAction,
  onRejectClick,
  actionVisibleInStatuses = ['pending', 're-submitted'],
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleMenuClick = (action,event) => {
    onAction?.(rowId, 'action', action, status,event);
    handleClose();
  };

  const canModerate = actionVisibleInStatuses
    .map(normalizeStatus)
    .includes(normalizeStatus(status));

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={(e) => handleMenuClick('View',e)}>
          <ListItemIcon sx={{ minWidth: '25px !important' }}>
            <VisibilityOutlinedIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary="View" primaryTypographyProps={{ fontSize: 14 }} />
        </MenuItem>

        {canModerate && (
          <>
            <MenuItem onClick={() => handleMenuClick('Approve')}>
              <ListItemIcon sx={{ minWidth: '25px !important' }}>
                <CheckCircleOutlineIcon sx={{ fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText primary="Approve" primaryTypographyProps={{ fontSize: 14 }} />
            </MenuItem>

            <MenuItem onClick={() => { onRejectClick?.(rowId, status); handleClose(); }}>
              <ListItemIcon sx={{ minWidth: '25px !important' }}>
                <HighlightOffOutlinedIcon sx={{ fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText primary="Rework" primaryTypographyProps={{ fontSize: 14 }} />
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
};

export default ActionDropdown;
